import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  label: string;
  icon: ReactNode;
  textColor: string;
  borderColor: string;
  fullWidth?: boolean;
}

const ProofingStatusPill = ({
  label,
  icon,
  textColor,
  borderColor,
  fullWidth = false,
}: IProps) => {
  const { t } = useTranslation();
  const dir: "rtl" | "ltr" = t("direction");

  const iconBox = (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {icon}
    </Box>
  );

  const labelText = (
    <Typography
      sx={{
        fontSize: "13px",
        fontWeight: 600,
        color: textColor,
        lineHeight: 1.2,
        textAlign: "start",
        flex: fullWidth ? 1 : undefined,
        minWidth: 0,
      }}
    >
      {label}
    </Typography>
  );

  return (
    <Box
      sx={{
        direction: dir,
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: fullWidth ? "6px 10px" : "4px 12px",
        borderRadius: fullWidth ? 0 : "9999px",
        border: `1px solid ${borderColor}`,
        backgroundColor: "#FFFFFF",
        whiteSpace: "nowrap",
        ...(fullWidth
          ? {
              width: "100%",
              boxSizing: "border-box",
              justifyContent: "flex-start",
            }
          : {
              display: "inline-flex",
            }),
      }}
    >
      {iconBox}
      {labelText}
    </Box>
  );
};

export { ProofingStatusPill };
